import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ContentService } from '../../spartacus/services/content.service';
import { Observable, combineLatest } from 'rxjs';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { ExternalLinkModalComponent } from '../../cms-common/external-link-modal/external-link-modal.component';
 
@Component({
    selector: 'app-custom-carousel',
    templateUrl: './custom-carousel.component.html',
    styleUrls: ['./custom-carousel.component.scss'],
    standalone: false
})
 
export class CustomCarouselComponent implements OnInit {
  thirdnode: Observable<any> = this.bannerComponent.data$;
  mergedObject1: any = [];
  toggleArray: any = [];
  subTileData: any = [];
  subTileData1: any = [];
  selectedTile: any;
  selectedTileIndex: number | null = 0; // Default to the first tile
  mergedResults: any;
  item: any;
  activeIndex = 0;
  factorData: any[] = [];
  vaccineFactors: string[] = [];

  popupdata: any;
  constructor(
    protected paraService: ContentService,
    private accessService: ContentService,
    public bannerComponent: CmsComponentData<CmsBannerComponent>,
    protected config: OccConfig,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private overlay: Overlay
  ) {}
 
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.desktop.url;
  }
  getImage1(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.url;
  }
  ngOnInit() {
    this.thirdnode.subscribe((res: any) => {
      this.productTabs(res);
    });
    this.paraService.getNavigation(this.popupKey).subscribe((res) => {
      this.popupdata = res;
    });
  }

  get popupKey(): string {
    return this.bannerComponent.uid == 'aQIVCarausalData'
      ? 'aTIVPopUp'
      : 'TIVcPopUp';
  }



  openExternalLinkModal(url?: string) {
    this.dialog.open(ExternalLinkModalComponent, {
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      data: { popupdata: this.popupdata, url },
      disableClose: true,
      hasBackdrop: true,
      autoFocus: false,
      restoreFocus: true,
      panelClass: 'external-link-dialog-panel',
      backdropClass: 'custom-backdrop'
    });
  }

  productTabs(res: any) {
    const prodList = res.AllResources.split(" ");
    this.accessService.opeffeaturedResources(prodList).subscribe((mergedResults: any) => {
      if (Array.isArray(mergedResults.component)) {
        this.mergedObject1 = mergedResults.component;
      }
      else if (res.component) {
        this.mergedObject1 = [mergedResults.component];
      }
      else {
        this.mergedObject1 = [];
      }
      this.cd.detectChanges();
      this.mergedObject1.forEach((item: any) => {
        if (item?.fourthCOMP?.vaccineInfoFeaturedResourcesfactor) {
          const factors =
            item.fourthCOMP.vaccineInfoFeaturedResourcesfactor.split(' ');
          this.vaccineFactors = factors;
          this.accessService.opeffeaturedResources(factors).subscribe((res: any) => {
            if (Array.isArray(res.component)) {
              this.factorData = res.component;
            } else if (res.component) {
              this.factorData = [res.component];
            }
            this.cd.detectChanges();
          });
        }
      });
    });
  }
  setActive(index: number) {
    this.activeIndex = index;
  }
}
